import { useMutation } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { apis } from 'probonio-shared-ui/module/api';
import { useMeStateSelector } from 'probonio-shared-ui/module/me/types';
import { useTranslation } from 'react-i18next';

export function useTenantContractsDownloadUrl() {
  const tenantId = useMeStateSelector(state => state.me.currentTenantId);
  const { t } = useTranslation('extensions');

  return useMutation({
    mutationFn: async () => {
      if (!tenantId) {
        throw new Error('Missing current tenant id');
      }

      const res = await apis.bikeLeasingV2.getTenantContractsDownloadUrl({ tenantId });

      if (!res.data.downloadUrl) {
        throw new Error('Missing download URL in response');
      }

      return res.data;
    },
    onError: () =>
      enqueueSnackbar({
        variant: 'error',
        message: t('bikeleasing_v2.contractsTable.downloadError'),
      }),
  });
}
